import { PatientUser } from '~/shared/types'
import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'
import { programsPrimaryCarePendingDischargeV2 } from '@fireflyhealth/api'
import { FFModal } from '~/shared/ui'
import { listProgramEnrollmentsKey } from '~/entities/program'
import { queueNotification } from '~/shared/notifications/actions'

interface ChurnMemberModelProps {
  patient: PatientUser
  handleClose: () => void
  open: boolean
}

const CancelDischrgeModel: FC<ChurnMemberModelProps> = props => {
  const dispatch = useDispatch()
  const client = useQueryClient()

  const handleStopDischarge = async () => {
    try {
      // PATCH API triggers signal -> defers case -> case side effect calls discharge_canceled()
      // which clears both ProgramEnrollment and PrimaryCareProgramInfo data
      await programsPrimaryCarePendingDischargeV2.partialUpdate(
        { user_id: `${props.patient.id}` },
        { data: { pending_discharge_reason: null } },
      )
      await client.cancelQueries({
        queryKey: [listProgramEnrollmentsKey, props.patient.person.id],
      })
      await client.invalidateQueries({
        queryKey: [listProgramEnrollmentsKey, props.patient.person.id],
      })
      props.handleClose()
    } catch (e: unknown) {
      const err = e as {
        response?: { data?: { pending_discharge_reason?: string[]; error?: string } }
      }
      const errorMessage =
        err?.response?.data?.pending_discharge_reason?.[0] ||
        err?.response?.data?.error ||
        'Failed to cancel discharge'
      dispatch(queueNotification({ variant: 'error', message: errorMessage }))
    }
  }

  return (
    <FFModal open={props.open} style={{ width: '60%' }}>
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3, ml: 4 }}>
          <Typography variant="h6">Stop Discharge Process</Typography>
          <Box sx={{ mt: 4, mr: 6 }}>
            <Typography variant="body1">
              Discharge is currently in progress for this member. Do you want to stop the discharge
              process?
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 4, py: 4 }}>
          <Box sx={{ mr: 1 }}>
            <Button disabled={false} onClick={props.handleClose} color="primary">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={false}
              variant="contained"
              color="primary"
              onClick={() => void handleStopDischarge()}
            >
              Yes, Stop Discharge
            </Button>
          </Box>
        </Box>
      </Box>
    </FFModal>
  )
}

export default CancelDischrgeModel
